/*
* finance.js v0.1
* By: Trent Richardson [http://trentrichardson.com]
*
* Copyright 2012 Trent Richardson
* You may use this project under MIT or GPL licenses.
* http://trentrichardson.com/Impromptu/GPL-LICENSE.txt
* http://trentrichardson.com/Impromptu/MIT-LICENSE.txt

modified for homebot and node

*/


if(typeof window !== 'undefined' && window.moment)
  var moment = window.moment;
else if(typeof require !== 'undefined')
  var moment  = require('moment');


var finance = /** @exports finance */ {

  	version : '0.1',

  	/*
  	*	Defaults
  	*/
  	settings : {
  		format: 'number',
  		formats: {
  				USD: { before: '$', after: '', precision: 0, decimal: '.', thousand: ',', group: 3, negative: '-' }, // $
  				GBP: { before:'£', after: '', precision: 2, decimal: '.', thousand: ',', group: 3, negative: '-' }, // £ or &#163;
  				EUR: { before:'€', after: '', precision: 2, decimal: '.', thousand: ',', group: 3, negative: '-' }, // € or &#8364;
  				percent: { before: '', after: '%', precision: 0, decimal: '.', thousand: ',', group: 3, negative: '-' },
  				number: { before: '', after: '', precision: null, decimal: '.', thousand: ',', group: 3, negative: '-'},
  				defaults: { before: '', after: '', precision: 0, decimal: '.', thousand: ',', group: 3, negative: '-' }
  			}
  	},

  	defaults : function(object, defs) {
  		var key;
  		object = object || {};
  		defs = defs || {};

  		for (key in defs) {
  			if (defs.hasOwnProperty(key)) {
  				if (object[key] == null) object[key] = defs[key];
  			}
  		}
  		return object;
  	},


  	/*
  	*	Formatting
  	*/

  	// add a currency format to library
  	addFormat : function(key, options){
  		this.settings.formats[key] = this.defaults(options, this.settings.formats.defaults);
  		return true;
  	},

  	// remove a currency format from library
  	removeFormat : function(key){
  		delete this.settings.formats[key];
  		return true;
  	},

  	// format a number or currency test
  	format : function(num, settings, override){
  		num = parseFloat(num);

  		if(settings === undefined)
  			settings = this.settings.formats[this.settings.format];
  		else if(typeof settings == 'string')
  			settings = this.settings.formats[settings];
  		else settings = settings;
  		settings = this.defaults(settings, this.settings.formats.defaults);

  		if(override !== undefined)
  			settings = this.defaults(override, settings);

  		// set precision
  		if(settings.precision != null)
  			num = num.toFixed(settings.precision);

  		var isNeg = num < 0,
  			numParts = Math.abs(num).toString().split('.'),
  			baseLen = numParts[0].length;

  		// add thousands and group
  		numParts[0] = numParts[0].replace(/(\d)/g, function(str, m1, offset, s){
  				return (offset > 0 && (baseLen-offset) % settings.group == 0)? settings.thousand + m1 : m1;
  			});

  		// add decimal
  		num = numParts.join(settings.decimal);

  		// add negative if applicable
  		if(isNeg && settings.negative){
  			num = settings.negative[0] + num;
  			if(settings.negative.length > 1)
  				num += settings.negative[1];
  		}

  		return  settings.before + num + settings.after;
  	},

  	/*
  	*	Financing
  	*/

  	//	calculate total of principal + interest (yearly) for x months
  	calculateAccruedInterest : function(principal, months, rate){
  		var i = rate/1200;
  		return (principal * Math.pow(1+i,months)) - principal;
  	},

  	//	determine the amount financed
  	calculateAmount : function(finMonths, finInterest, finPayment){
  		var result = 0;

  		if(finInterest == 0){
  			result = finPayment * finMonths;
  		}
  		else{
  			var i = ((finInterest/100) / 12),
  				i_to_m = Math.pow((i + 1), finMonths),
  				a = finPayment / ((i * i_to_m) / (i_to_m - 1));
  			result = Math.round(a * 100) / 100;
  		}

  		return result;
  	},

    calculateAPR: function(loanAmount, numPayments, baseRate, costs){
      // based off of http://www.webmasterymadesimple.com/blog/javascript-function-for-calculating-annual-percentage-rate-a.html
      // loanAmount = the amount borrowed
      // numPayments = number of monthly payments e.g. 30 years = 360
      // baseRate = the base percentage rate of the loan. A 5.25% Annual Rate should be passed in as 0.0525 NOT 5.25
      // costs = the loan closing costs in dollars

      var rate = 	baseRate / 12;
      var totalMonthlyPayment = ((loanAmount+costs) * rate * Math.pow(1+rate,numPayments)) / (Math.pow(1+rate, numPayments)-1);
      var testRate = rate;
      var iteration = 1;
      var testResult = 0;

      //iterate until result === 0
      var testDiff = testRate;
      while (iteration <= 100) {
        testResult = ((testRate * Math.pow(1 + testRate, numPayments)) / (Math.pow(1 + testRate, numPayments) - 1)) - (totalMonthlyPayment / loanAmount);
        if (Math.abs(testResult) < 0.0000001) break;
        if (testResult < 0) testRate += testDiff;
        else testRate -= testDiff;
        testDiff = testDiff / 2;
        iteration++;
      }

      testRate = testRate * 12;
      testRate = testRate * 100; // convert to percentage
      return testRate.toFixed(6) / 1; // convert to float
    },

  	//	determine the months financed
  	calculateMonths : function(finAmount, finInterest, finPayment){
  		var result = 0;

  		if(finInterest == 0){
  			result = Math.ceil(finAmount / finPayment);
  		}
  		else{
  			result = Math.round(( (-1/12) * (Math.log(1-(finAmount/finPayment)*((finInterest/100)/12))) / Math.log(1+((finInterest/100)/12)) )*12);
  		}

  		return result;
  	},

  	//	determine the interest rate financed http://www.hughchou.org/calc/formula.html
  	calculateInterestRate : function(finAmount, finMonths, finPayment){
  		var result = 0;

  		var min_rate = 0, max_rate = 100;
  		while(min_rate < max_rate-0.0001){
  			var mid_rate = (min_rate + max_rate)/2,
  				j = mid_rate / 1200,
  				guessed_pmt = finAmount * ( j / (1-Math.pow(1+j, finMonths*-1)));

  			if(guessed_pmt > finPayment){
  				max_rate = mid_rate;
  			}
  			else{
  				min_rate = mid_rate;
  			}
  		}
  		return mid_rate.toFixed(2);
  	},

  	//	determine the payment
  	calculatePayment : function(finAmount, finMonths, finInterest){

  		finInterest = parseFloat(finInterest);

  		var result = 0;

  		if(finInterest == 0){
  			result = finAmount / finMonths;
  		}
  		else{
  			var i = ((finInterest/100) / 12),
  				i_to_m = Math.pow((i + 1), finMonths),
  				p = finAmount * ((i * i_to_m) / (i_to_m - 1));
  			result = Math.round(p * 100) / 100;
  		}

  		return result;
  	},

  	calculateFee : function(finAmount, pts){



  	},

    calculateInterest : function(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly){
  		var payment = this.calculatePayment(finAmount, finMonths, finInterest),
  			balance = finAmount,
  			totalInterest = 0.0,
  			isFuture = false,
  			ep = 0 ,
  			currInterest = null,
  			currPrincipal = null,
  			currDate = finDate ? new Date(finDate) : new Date();

  			currDate.setMonth(currDate.getMonth()+1);

  		if(biWeekly)
          	finMonths = finMonths/12*26;

  		for(var i=0; i<finMonths; i++){

  			if(finExtraPay && ep === 0 && moment(currDate.getTime()).isAfter(new Date())){
  				isFuture = true;
  				//don't calc payment unless its the future, not back dating extra payments
  				if(finExtraPay)
  					ep = (biWeekly)? finExtraPay/2 : finExtraPay;
  			}

  			currInterest = (isFuture && biWeekly)? balance * finInterest/2600 : balance * finInterest/1200;
  			totalInterest += currInterest;
  			currPrincipal = (isFuture && biWeekly)? payment/2 - currInterest + ep : payment - currInterest + ep;
  			balance -= currPrincipal;

  			if(balance<0)
  				break;

  			if(biWeekly)
  				currDate=moment(currDate.getTime()).add(14,'days')._d;
  			else
  				currDate.setMonth(currDate.getMonth()+1);
  		}

  		return totalInterest;
  	},

  	calculateAmortization : function(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly, endDate, extraPayments){

  			var payment = this.calculatePayment(finAmount, finMonths, finInterest),
  				balance = finAmount,
  				interest = 0.0,
  				totalInterest = 0.0,
  				totalPrincipal = 0.0,
  				schedule = [],
  				currInterest = null,
  				currPrincipal = null,
  				todayPrincipalPaid = null,
  				todayInterestPaid = null,
  				todayPrincipal = null,
  				todayInterest = null,
  				breakevenPayment = null,
  				breakevenDate = null,
  				isFuture = false,
  				totalExtraPayments = 0,
  				ep = 0,
  				lastMonth = 0,
  				endDate = (!!endDate) ? new Date(endDate) : new Date(), //used to calc total paid
  				currDate = finDate? new Date(finDate) : new Date();

  				currDate.setMonth(currDate.getMonth()+1);

  			//a year is now 26 payments instead of 12
  			if(biWeekly)
  				finMonths = finMonths/12*26;

  			for(var i=0; i<finMonths; i++){
  				//save what the Principal is now
  				if(!todayPrincipalPaid && moment(currDate.getTime()).isAfter(endDate)){
  					todayPrincipalPaid = totalPrincipal;
  					todayInterestPaid = totalInterest;
  					todayPrincipal = currPrincipal;
  					todayInterest = currInterest;

  					isFuture = true;
  					//don't calc payment unless its the future, not back dating extra payments
  					if(finExtraPay)
  						ep = (biWeekly)? finExtraPay/2 : finExtraPay;
  				}

  				/*
  				Extra Payments logic [{ amount,start_date,end_date }]
  				*/
  				if(extraPayments){
  					//reset ep
  					ep = 0;

  					for(var e=0; e<extraPayments.length; e++){
  						//if extra payment date falls after current date and before enddate if exists then add amount to principal
  						if(moment(currDate.getTime()).isAfter(new Date(extraPayments[e].start_date))
  							&& !extraPayments[e].end_date
  								|| (!!extraPayments[e].end_date
  									&& moment(currDate.getTime()).isBefore(new Date(extraPayments[e].end_date)))
  							){
  							if(isFuture && finExtraPay)
  								ep = (biWeekly)? finExtraPay/2 : finExtraPay;
  							ep += parseInt(extraPayments[e].amount,10);
  							totalExtraPayments += ep;
  							break;
  						} else {
  							if(isFuture && finExtraPay){
  								ep = (biWeekly)? finExtraPay/2 : finExtraPay;
  								totalExtraPayments += ep;
  							}
  						}
  					}
  				} else {
  					totalExtraPayments += ep;
  				}

  				currInterest = (isFuture && biWeekly)? balance * finInterest/2600 : balance * finInterest/1200;
  				totalInterest += currInterest;
  				currPrincipal = (isFuture && biWeekly)? payment/2 - currInterest + ep : payment - currInterest + ep;
  				balance -= currPrincipal;
  				totalPrincipal += currPrincipal;

  				/*
  				Break even logic, two reasons for this
  				1. calc what a one-time will be to get the principal payment is more than interest payment
  				2. calc date when principal payment is more than interest payment

  				If paying an extra payment, this should not be counted and must be removed from the currPrincipal since
  				it was added above. This will tell us the date when we can stop paying an extra payment
  				and have the principal payment more than the interest payment.
  				*/
  				if(!breakevenPayment && currPrincipal-ep > currInterest){
  					breakevenPayment = finAmount-balance;
  					breakevenDate = moment(currDate.getTime()).format("YYYY-MM-DD");
  				}

  				if(balance<0){
  					lastMonth = i;
  					break;
  				}

  				schedule.push({
  						balance: balance,
  						principal: totalPrincipal,
  						interest: totalInterest,
  						payment: (biWeekly)? payment/2+ep/2 : payment+ep,
  						paymentToPrincipal: currPrincipal,
  						paymentToInterest: currInterest,
  						extraPayment: ep,
  						date: moment(currDate.getTime()).format("YYYY-MM-DD")
  					});

  				if(biWeekly)
  					currDate=moment(currDate.getTime()).add(14,'days')._d;
  				else
  					currDate.setMonth(currDate.getMonth()+1);
  			}
  			return { 'amount': parseFloat(finAmount)
  				, 'rate': parseFloat(finInterest)
  				, 'periods': parseFloat(finMonths)
  				, 'periods_saved': (lastMonth===0) ? 0:((biWeekly)? finMonths-lastMonth/26*12 : finMonths-lastMonth)
  				, 'principal_paid': parseFloat(todayPrincipalPaid)
  				, 'interest_paid': parseFloat(todayInterestPaid)
  				, 'principal': parseFloat(totalPrincipal)
  				, 'interest': parseFloat(totalInterest)
  				, 'extra_payment_total': parseFloat(totalExtraPayments)
  				, 'payment': {
  					  'total': parseFloat(payment)
  					, 'principal': parseFloat(todayPrincipal)
  					, 'interest': parseFloat(todayInterest)
  				}
  				, 'break_even_payment': parseFloat(breakevenPayment)
  				, 'break_even_date': breakevenDate
  				, 'extra_payment': parseFloat(finExtraPay)
  				, 'start_date': moment(finDate).format("YYYY-MM-DD")
  				, 'maturity_date': schedule[schedule.length-1]['date']
  				, 'schedule': schedule
  			};
  	},

  	getMaturityDate : function(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly){

  		var amortization = this.calculateAmortization(finAmount, finMonths, finInterest, finDate, finExtraPay, biWeekly);

  		var maturity_date = amortization.schedule[amortization.schedule.length-1]['date'];
  		var interest = amortization.schedule[amortization.schedule.length-1]['interest'];

  		//update periods to reflect months since sold
  		var soldDate = moment(finDate);
  		finMonths = finMonths + soldDate.diff(moment(),'months');

  		//get time savings from amortization
  		var date = moment( amortization.schedule[amortization.schedule.length-1]['date'] );
  		var months_saved = finMonths-date.diff(moment(), 'months');

  		return {
  			 'date': maturity_date
  			,'months_left': finMonths-months_saved
  			,'interest_paid': interest
  			,'extra_paid': finExtraPay
  			,'time_savings': {
  				'years': parseInt( months_saved/12, 10)
  				, 'months': months_saved%12
  			}
  		};
  	}

};


if(typeof module !== 'undefined' && module.exports){
  module.exports = finance;
}else if(typeof window !== 'undefined'){
  window.finance = finance;
}
